import ReducerRegistry from '../base/redux/ReducerRegistry';
import chatLogReducer from './reducer';
ReducerRegistry.register('features/chat-log', chatLogReducer);
